import React from "react";
import {Route, Switch} from "react-router-dom";
import BusinessCardRequestsExporter from "./BusinessCardRequestsExporter";
import BusinessCardRequestsViewDetails from "./BusinessCardRequestsViewDetails";



const App = ({match}) => (
  <Switch>
    <Route exact path={`${match.url}`} component={BusinessCardRequestsExporter}/>
    <Route path = {`${match.url}/view-details/:id`} component={BusinessCardRequestsViewDetails}/>
  </Switch>
);

export default App;
